/**
 * BundleState wire values (TDF-1342). BundleState serializes via @JsonValue
 * to its i18n message key — NOT the raw enum name — same pattern as the
 * sibling SrState enum (corrected in the contract 2026-09-07; earlier code
 * checked raw names like 'PENDING_ACTIVATION', which the real API never
 * sends). Full 22-value enum per the contract's State reference table.
 */
export const BUNDLE_STATE = {
  SUBMITTED: 'bundle.state.submitted',
  PROPOSAL_ROUTE_DECIDED: 'bundle.state.proposal_route_decided',
  PROPOSAL_RECEIVED: 'bundle.state.proposal_received',
  PROPOSAL_ACCEPTED: 'bundle.state.proposal_accepted',
  PROPOSAL_REJECTED: 'bundle.state.proposal_rejected',
  CONTRACT_ROUTE_DECIDED: 'bundle.state.contract_route_decided',
  CONTRACT_RECEIVED: 'bundle.state.contract_received',
  CONTRACT_SIGNED: 'bundle.state.contract_signed',
  CONTRACT_UNDER_REVIEW: 'bundle.state.contract_under_review',
  MSA_ADDENDUM_IN_PROGRESS: 'bundle.state.msa_addendum_in_progress',
  MSA_ADDENDUM_SUBMITTED: 'bundle.state.msa_addendum_submitted',
  MSA_ADDENDUM_APPROVED: 'bundle.state.msa_addendum_approved',
  MSA_ADDENDUM_REJECTED: 'bundle.state.msa_addendum_rejected',
  CONTRACT_APPROVED: 'bundle.state.contract_approved',
  CONTRACT_REJECTED: 'bundle.state.contract_rejected',
  PO_ROUTE_DECIDED: 'bundle.state.po_route_decided',
  PO_REQUIRED: 'bundle.state.po_required',
  PO_SUBMITTED: 'bundle.state.po_submitted',
  PO_APPROVED: 'bundle.state.po_approved',
  PO_REJECTED: 'bundle.state.po_rejected',
  PENDING_ACTIVATION: 'bundle.state.pending_activation',
  SPLIT_COMPLETE: 'bundle.state.split_complete',
  ERROR: 'bundle.state.error',
} as const;

/** rejectedStep values — same 4 strings SrStatusResponse.rejectedStep uses. */
export const BUNDLE_REJECTED_STEP = {
  PROPOSAL: 'proposal',
  CONTRACT: 'contract',
  PO: 'po',
  MSA_ADDENDUM: 'msa-addendum',
} as const;
